import React from 'react';
import Link from 'next/link';
import { TCloudinaryImageShape } from '../../CloudinaryResponsiveImage/types';
import Typo from '../../Typography';
import getUserDisplayName from '../../../../utils/getUserDisplayName';
import DotSeparator from './DotSeparator';
import { TCommentProps } from '../CommentsList';
import T2UserProfileImage from '../../UserProfileImage/UserProfileImage';
import { getUserPageUrl } from '../../../services/pagesUrl/getUserPageUrl';
import { TCommentOrigin } from '../types';
import { T2ProfileCardContainer } from '../../ProfileCard/T2ProfileCardContainer';
import { PROFILE_CARD_HOVER_DELAY } from '../../ProfileCard/constants';
import { UnstyledTooltip } from '../../Tooltip/UnstyledTooltip';

type TCommentAuthor = {
  author: TCommentProps['author'];
  commentOrigin: TCommentOrigin;
};

export const CommentAuthor: React.FC<TCommentAuthor> = ({ author, commentOrigin }) => {
  const hrefs = {
    t2: getUserPageUrl(author?.username as string),
  };

  const Username = (
    <Typo
      variant="small-p"
      text={getUserDisplayName(author)}
      className="-mt-5 md:mt-0 !text-base text-black-700 !font-semibold"
    />
  );

  const T2UserLink = (
    <UnstyledTooltip
      direction="right"
      floatingUIHover={PROFILE_CARD_HOVER_DELAY}
      trigger={
        <Link href={hrefs[commentOrigin]} target="_blank">
          <div className="flex items-center gap-x-2 hover:opacity-80">
            <T2UserProfileImage profileImage={author?.profileImage as TCloudinaryImageShape} size="medium" />
            {Username}
          </div>
        </Link>
      }
    >
      <T2ProfileCardContainer id={author?.id as string} />
    </UnstyledTooltip>
  );

  return (
    <>
      {T2UserLink}
      <DotSeparator />
    </>
  );
};
